import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from "@material-ui/icons/ExpandMore";


const styles = theme => ({
  cardRoot: {
    // boxShadow: "none",
    // borderRadius: "0em 1em 1em",
    // border: "1px solid rgb(222, 225, 229)"
  },
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: "10%"

    // borderStyle: "solid",
    // borderWidth: "1px",
    // borderRight: "none",
    // borderLeft: "none",
    // borderColor: "rgb(222, 225, 229)"
  },
  text: {
    fontSize: "15px",
    marginLeft: "15px",
    color: theme.palette.primary.main,
    fontFamily: "'open_sans',Helvetica,Arial,sans-serif",
    lineHeight: "15px",
    fontWeight: 600,
    marginTop: "5px",
    marginBottom: "5px",
    
  },
  text2: {
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: "'open_sans',Helvetica,Arial,sans-serif",
    fontSize: "15px",
    background: "-webkit-linear-gradient(#333, #eee); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"
  },
  textDesplegable: {
    fontSize: "15px",
    color: "#333333",
    lineHeight: "15px",
    fontFamily: "'open_sans',Helvetica,Arial,sans-serif",
    fontWeight: 600
  },
  divDesplegable: {
    padding: "0",
    paddingBottom: "4px",
    paddingTop: "6px"
  },
  item: {
    padding: 3
  },
  headers: {
    fontSize: "15px",
    fontFamily: "'open_sans',Helvetica,Arial,sans-serif",
  },
  listSubheader: {
    fontSize: "15px",
    fontWeight: 600,
    fontFamily: "'open_sans',Helvetica,Arial,sans-serif",
    color: "#333333"
  },
  divList: {
    borderStyle: "solid",
    borderWidth: "1px",
    borderRight: "none",
    borderLeft: "none",
    borderColor: "rgb(222, 225, 229)"
  }
});

class DesplegableDoble extends React.Component {
  state = {
  };

  handleClick = menu => {
    this.setState({ [menu]: !this.state[menu] });
  };

  buttonClick = event => {
    this.props.onButtonClick(event);
  };

  render() {
    const { classes } = this.props;
    const { data } = this.props;
    return (
      <Card
        style={{
          boxShadow: "none",
          borderRadius: "0em 1em 1em",
          border: "1px solid rgb(222, 225, 229)",
          marginRight: "auto",
          width: "276px"
        }}
      >
          {data.map(t => {
            if (t.type === "boton") {
              return (
                <div
                  style={{
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderRight: "none",
                    borderLeft: "none",
                    borderColor: "rgb(222, 225, 229)",
                    borderBottom: "none"
                  }}
                  key={data.indexOf(t)}
                >
                  <ListItem
                    className={classes.item}
                    button
                    onClick={()=>{this.buttonClick(t)}}
                    style={{flexDirection:"column"}}
                  > 
                    <ListItemText
                      disableTypography
                      style={{alignSelf:"flex-start"}}
                      primary={
                        <Typography className={classes.text} >
                          {t.text_label}
                        </Typography>
                      }
                    />
                    </ListItem>
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderRight: "none",
                    borderLeft: "none",
                    borderColor: "rgb(222, 225, 229)",
                    borderBottom: "none"
                  }}
                  key={data.indexOf(t)}
                >
                  <ListItem
                    className={classes.item}
                    button
                    onClick={() => {
                      this.handleClick(t.data);
                    }}
                  >
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography className={classes.text}>
                          {t.label}
                        </Typography>
                      }
                    />
                    {this.state[t.data] ? (
                      <ExpandLess
                      color="primary"
                      style={{ marginRight: "0.6em" }}
                    />
                    ) : (
                      <ExpandMore
                        color="primary"
                        style={{ marginRight: "0.6em" }}
                      />
                    )}
                  </ListItem>
                  {t.labels.map(m => (
                    <div key={t.labels.indexOf(m)}>
                      <Collapse
                        in={this.state[t.data]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          <ListItem
                            style={{
                              backgroundColor: "#F2F2F2",
                              borderStyle: "solid none",
                              borderWidth: "1px medium",
                              borderColor: "rgb(222, 225, 229)",
                              borderBottom: "none"
                            }}
                            button
                            className={classes.nested}
                            onClick={()=>{this.buttonClick(m)}}
                          >
                            <ListItemText
                              disableTypography
                              className={classes.divDesplegable}
                              primary={
                                <Typography className={classes.textDesplegable}>
                                  {m.text_label}
                                </Typography>
                              }
                            />
                          </ListItem>
                        </List>
                      </Collapse>
                    </div>
                  ))}
                </div>
              );
            }
          })}
      </Card>
    );
  }
}

export default withStyles(styles)(DesplegableDoble);